import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import { useUserStore } from './stores/user'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import secureStorage from './utils/secureStorage'
import { enforceLatestVersion } from './utils/versionCheck'

const bootstrap = async () => {
  const shouldStopBootstrap = await enforceLatestVersion()
  if (shouldStopBootstrap) {
    return
  }

  const app = createApp(App)
  const pinia = createPinia()

  app.use(pinia)
  app.use(router)
  app.use(ElementPlus)

  // 初始化用户认证信息
  const userStore = useUserStore()
  userStore.initializeAuth()

  // 开发环境下暴露调试方法，便于在浏览器控制台查看 token 等信息
  if (process.env.NODE_ENV === 'development') {
    // 查看加密存储中的 token：在控制台执行 window.__getToken()
    window.__getToken = () => secureStorage.get('token')
    // Pinia 用户状态：在控制台执行 window.__userStore
    window.__userStore = userStore
  }

  app.mount('#app')
}

bootstrap()
